(function () {
    'use strict';
    angular.module('app').directive('selectioncommandcheckout', selectioncommand_checkout);
    function selectioncommand_checkout() {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                checkOutDialogShown: '=?'
            },
            controller: 'checkout',
            templateUrl: 'app/selectioncommand/selectioncommand_checkout.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();